import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface IPhoneInputContainerProps {
  isFocused: boolean;
  isErrored?: boolean;
}

interface ILabelProps {
  isFocused: boolean;
}

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const PhoneInputContainer = styled.div<IPhoneInputContainerProps>`
  ${({ theme, isFocused, isErrored }) => css`
    display: flex;
    position: relative;
    background: ${theme.colors.background};
    border-radius: ${theme.radius.large};
    box-shadow: ${theme.shadows.default};
    padding: 10px;
    width: 100%;
    margin: 0.6rem 0.6rem 0.6rem 0.6rem;
    border: 1px solid ${theme.colors.strongRed};
    align-items: center;

    svg {
      color: #cecece;
      margin: 0 6px;
    }

    ${isFocused &&
    css`
      border: 1px solid ${theme.colors.brightOrange};
      color: ${theme.colors.primary};

      > svg {
        color: ${theme.colors.primary};
      }
    `}

    ${isErrored &&
    css`
      border: 1px solid ${theme.colors.strongRed};

      > svg {
        color: ${theme.colors.error};
      }
    `}

    input {
      flex: 1;
      border: 0;
      background: transparent;
      font-size: 1.6rem;
    }

    button {
      background-color: transparent;
    }
  `}
`;

export const Label = styled.label<ILabelProps>`
  ${({ theme, isFocused }) => css`
    width: 0;
    height: 0;
    font-size: ${theme.fontSizes.default};
    white-space: nowrap;

    ${isFocused &&
    css`
      color: ${theme.colors.primary};
    `}
  `}
`;

export const Error = styled(Tooltip)`
  ${({ theme }) => css`
    height: 20px;

    svg {
      margin-right: 0;
    }

    span {
      background: ${theme.colors.secondary};
      color: #fff;
    }

    &::before {
      border-color: ${theme.colors.secondary} transparent;
    }
  `}
`;
